export default "__VITE_PUBLIC_ASSET__4c5630da__"